<div>
  <div class="grid grid-cols-1 md:grid-cols-5 gap-6 py-6">
    <app-progress-dashboard-box
      id="total-attributes-box"
      [label]="'progress.dashboard.box.total-attributes.label' | transloco: {phase: phase()}"
      [value]="totalAttributes()"
      [type]="ProgressDashboardBoxType.TOTAL"
    />

    <app-progress-dashboard-box
      id="completed-attributes-box"
      [label]="'progress.dashboard.box.completed-attributes.label' | transloco"
      [value]="completedSubCriteria()"
      [type]="ProgressDashboardBoxType.COMPLETED"
    />

    <app-progress-dashboard-box
      id="pct-completion-attributes-box"
      [label]="'progress.dashboard.box.pct-completion-attributes.label' | transloco"
      [value]="pctCompleted()"
      [type]="ProgressDashboardBoxType.PCT_COMPLETED"
    />

    <app-progress-dashboard-box
      id="num-evaluation-criteria-box"
      [label]="'progress.dashboard.box.num-evaluation-criteria.label' | transloco"
      [value]="numCriteria()"
      [type]="ProgressDashboardBoxType.NUM_CRITERIA"
    />

    <app-progress-dashboard-box
      id="num-evaluation-sub-criteria-box"
      [label]="'progress.dashboard.box.num-evaluation-sub-criteria.label' | transloco"
      [value]="numSubCriteria()"
      [type]="ProgressDashboardBoxType.NUM_SUB_CRITERIA"
    />
  </div>
  <p-accordion class="columns-1">
    <p-accordion-panel value="0">
      <p-accordion-header>{{ 'progress.dashboard.show.details' | transloco }}</p-accordion-header>
      <p-accordion-content>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-5">
          @if (phase() === 'RFI') {
            <app-progress-dashboard-rfi-bar-chart-container
              [label]="'progress.dashboard.criteria.completion.chart.label' | transloco"
              [subCriteriaAttributes]="flattenedAttributesByEvaluationCriteriaMap()"
              [subEvaluationCriteria]="evaluationSubCriteria()"
            />
          } @else {
            <app-progress-dashboard-rfp-bar-chart-container
              [label]="'progress.dashboard.criteria.completion.chart.label' | transloco"
              [subCriteriaAttributes]="flattenedAttributesByEvaluationCriteriaMap()"
              [evaluationCriteria]="evaluationCriteria()"
            />
          }

          <app-progress-dashboard-pie-chart-container
            [label]="
              pieChartLabel() || 'progress.dashboard.rating.distribution.chart.label' | transloco
            "
            [subCriteriaAttributes]="flattenedAttributesByEvaluationCriteriaMap()"
          />
        </div>
        <div class="columns-1">
          @if (phase() === 'RFI') {
            <app-progress-dashboard-rfi-table
              [label]="'progress.dashboard.table.label' | transloco: {phase: phase()}"
              [subCriteriaAttributes]="flattenedAttributesByEvaluationCriteriaMap()"
              [subEvaluationCriteria]="evaluationSubCriteria()"
            />
          } @else {
            <app-progress-dashboard-rfp-table
              [label]="'progress.dashboard.table.label' | transloco: {phase: phase()}"
              [subCriteriaAttributes]="flattenedAttributesByEvaluationCriteriaMap()"
              [evaluationCriteria]="evaluationCriteria()"
            />
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
